import { graphql } from 'react-relay';

/**
 * The three `Apis.Admin` operational dials over a feature flag. Each returns the
 * flag's full `FeatureFlagState` so the caller can reconcile optimistic UI with
 * the server's authoritative values. Kept in `relay/` (not a screen) so the
 * `graphql` tag stays confined to Babel-transformed data modules.
 */

/** Advance / retreat a flag's rollout stage (Off → Internal → Beta → GA). */
export const setStageMutation = graphql`
    mutation featureFlagMutationsSetStageMutation($key: FeatureKey!, $stage: FeatureStage!) {
        setStage(key: $key, stage: $stage) {
            key
            stage
            killed
            percent
            kind
        }
    }
`;

/** Throw or release a flag's kill switch. */
export const setKilledMutation = graphql`
    mutation featureFlagMutationsSetKilledMutation($key: FeatureKey!, $killed: Boolean!) {
        setKilled(key: $key, killed: $killed) {
            key
            stage
            killed
            percent
            kind
        }
    }
`;

/** Set a flag's GA percentage ramp (0–100). */
export const setPercentMutation = graphql`
    mutation featureFlagMutationsSetPercentMutation($key: FeatureKey!, $percent: Int!) {
        setPercent(key: $key, percent: $percent) {
            key
            stage
            killed
            percent
            kind
        }
    }
`;
